import type { State } from 'types/redux'
import { getSubscriptionPricingVariant } from '@disco/state-management/selectors/subscription'
import { getPrePopulatedSubscriptionData } from '@disco/state-management/selectors/user'
import { pricingPlans, legacyPricingPlans } from '@disco/utils/pricing'
/**
 * Gets the pricing plans available for the current subscription.
 * @param state - The Redux state
 * @returns Array of pricing plan objects
 */
export const getPlans = (state: State): any[] => {
  const plansTabs = state.forms.pricingForm.plansTabs
  const { available_plans } = getPrePopulatedSubscriptionData(state)
  const activeTab = plansTabs.active
  // activeTab isn't selected
  if (typeof activeTab !== 'number') return []
  const planIds = available_plans || plansTabs.ids[activeTab]
  const subscriptionPricingPlans =
    getSubscriptionPricingVariant(state) === '2020-pricing'
      ? legacyPricingPlans
      : pricingPlans

  return subscriptionPricingPlans.filter(({ handle }) =>
    planIds.includes(handle),
  )
}
